import { loadRemote } from "@module-federation/enhanced/runtime";
import type { LoadParcel } from "@spiriidk/connect-configs/parcels";

const loadParcel: LoadParcel = async (name) => {
  const connectModule = await loadRemote<Awaited<ReturnType<LoadParcel>>>(
    `spirii_connect/parcels/${name}`
  );
  if (!connectModule) {
    throw new Error(`Connect did not provide the parcel "${name}"`);
  }
  return connectModule;
};

export { loadParcel };
